import { lazy } from 'react';

const ConfigurationEdit = lazy(() => import('./configuration-edit'));;

export default {
  ConfigurationEdit,
};
